import { Controller } from '@hotwired/stimulus'
import DownloadCsvFromArray from '../helpers/download_csv_from_array'

export default class extends Controller {
    static targets = ['table']
    static values = {
        filename: { type: String, default: 'top_metrics' },
        exportData: { type: Array, default: [] }
    }

    exportCsv() {
        const headers = []
        this.tableTarget.querySelectorAll('thead th').forEach(th => {
            const text = th.textContent.trim()
            headers.push(text)
        })

        DownloadCsvFromArray.downloadableCSV(this.exportDataValue, `${this.filenameValue}.csv`, headers)
    }
}
